import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { EmailShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';
import styles from './index.module.scss';
import { giftMap, svgMapH5, productInfoMap } from '@/data/ecocreditsday';
import { termsMap } from '@/data/ecocreditsday/term';
import { createEFPic } from '@/utils/useEFPic';
import DialogBox from '@/componentsH5/EcoCreditsDay/components/DialogBox';
import { useLang } from '@/i18n';
import request from '@/request';
import gtm from '@/utils/gtm';

const { EFPic } = createEFPic('/media/ecocredits-day/h5/');
const WEB_SITE = 'www.ecoflow.com';

export default function Lottery() {
    const { locale } = useRouter();
    const { t } = useLang('ecocreditsday.pageTabs.tabA.lottery');

    const lotteryData: Record<string, any> = giftMap[locale as keyof typeof giftMap] || giftMap.jp;
    const termsData: Record<string, any> = termsMap[locale as keyof typeof termsMap] || null;
    const svgList = svgMapH5[locale as keyof typeof svgMapH5] || svgMapH5.jp;
    const productInfoData = productInfoMap[locale as keyof typeof productInfoMap] || productInfoMap.us;
    const leftImgMap = {
        jp: ['gift_box_jp.webp', 'gift_box_jp.png'],
        kr: ['gift_box_kr.webp', 'gift_box_kr.png'],
        za: ['gift_box_za.webp', 'gift_box_za.png'],
        eu: ['gift_box_eu.webp', 'gift_box_eu.png'],
        us: ['gift_box_us.webp', 'gift_box_us.png'],
        ca: ['gift_box_us.webp', 'gift_box_us.png'],
        au: ['gift_box_au.webp', 'gift_box_au.png'],
        uk: ['gift_box_uk.webp', 'gift_box_uk.png'],
    };
    const imgName = leftImgMap[locale as keyof typeof leftImgMap] || leftImgMap.eu;
    const [visible, setVisible] = useState(false);
    const [productInfoVisible, setProductInfoVisible] = useState(false);
    const [markIndex, setMarkIndex] = useState(-1);

    const heightMap = { jp: 210, kr: 324, za: 438 };

    // 进度条总长度
    const progressHeight = heightMap[locale as keyof typeof heightMap] || heightMap.za;
    // 进度条进度
    const [activeHeight, setActiveHeight] = useState(0);
    // 当前人数
    const [completeNumber, setCompleteNumber] = useState(0);
    // 中奖列表
    const [winnerList, setWinnerList] = useState([]);
    const [winnerDialog, setWinnerDialog] = useState(false);
    const [isCoupon, setIsCoupon] = useState(false);
    const [enableArr, setEnableArr] = useState<any[]>([]);
    const hideWinner = ['kr', 'au', 'za'].includes(locale as string);

    let locationHref = '';
    if (typeof window !== 'undefined') {
        locationHref = location.href;
    }

    const handleDialogClose = () => {
        setVisible(false);
    };

    const handleLinkClick = () => {
        setVisible(true);
    };

    const getEnableClick = async () => {
        try {
            const res: any = await request({ method: 'GET', url: '/api/getEnableClick', query: { activityId: 1, locale: locale as string } });
            if (res.data.code === '0') {
                setEnableArr(res.data.data || []);
            }
        } catch (e) {
            setEnableArr([]);
        }
    };

    const getProgress = async () => {
        try {
            getEnableClick().catch(console.error);
            const res: any = await request({ method: 'GET', url: '/api/getEcoCreditsDayProgress', query: { activityId: 1, locale: locale as string } });
            const resData = res.data.data || {};
            const currentNumber = resData.completeNumber || 0;
            setCompleteNumber(currentNumber);
            const currentList = lotteryData.list.filter((item: any) => item.number <= currentNumber);
            const currentData = currentList[currentList.length - 1];
            if (!currentData) {
                currentNumber > lotteryData.list[0].number
                    ? setActiveHeight(progressHeight)
                    : setActiveHeight(currentNumber * lotteryData.list[0].heightPercent);
            } else {
                const nextHeight = (currentNumber - currentData.number) * currentData.nextHeightPercent;
                const height = nextHeight + currentData.allHeight > progressHeight ? progressHeight : nextHeight + currentData.allHeight;
                setActiveHeight(height);
            }
        } catch (e) {
            setActiveHeight(0);
            setCompleteNumber(0);
        }
    };

    const showWinnerList = async (item: any, stageId: number) => {
        setIsCoupon(!!item.isCoupon);
        setWinnerDialog(true);
        if (!item.isCoupon) {
            try {
                const res: any = await request({
                    method: 'GET',
                    url: '/api/getWinnerList',
                    query: { activityId: 1, stageId, locale: locale as string },
                });
                if (res.data.code === '0') {
                    setWinnerList(res.data.data || []);
                }
            } catch (e) {
                setWinnerList([]);
            }
        }
    };

    const gtmPush = (btnName: string) => {
        if (locale !== 'jp') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'share',
                method: btnName,
                item_id: 'Ecocredits-day',
            });
        }
    };

    useEffect(() => {
        getProgress().catch(console.error);
        const isProd = process.env.NEXT_PUBLIC_MODY === 'prd';
        const localeTime = localStorage.getItem('lottery_test_time') || 0;
        const timer = setInterval(getProgress, !isProd && localeTime ? Number(localeTime) : 5 * 60 * 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    const renderDialogContext = () => {
        if (!!termsData) {
            return (
                <div>
                    {termsData.map((termItem: any) => (
                        <>
                            <div className="terms-title">{termItem?.title}</div>

                            {termItem?.desc.map((item: any, index: number) => (
                                <div key={item}>
                                    <div
                                        className="terms-item"
                                        key={item}
                                        dangerouslySetInnerHTML={{
                                            __html: item,
                                        }}
                                    >
                                        {/* {handleLinkStrReplace(item)} */}
                                    </div>
                                    {termItem?.info && termItem?.info[`text_${index}`] && (
                                        <div>
                                            {termItem?.info[`text_${index}`]?.map((infoItem: any) => (
                                                <div key={infoItem}>{infoItem}</div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </>
                    ))}
                </div>
            );
        }
        return t.rich('rules_content', {
            line1: (text: string) => <div className="line-text">{text}</div>,
        });
    };

    const handleMarkClick = (index: number) => {
        setMarkIndex(index);
        setProductInfoVisible(!productInfoVisible);
    };
    return (
        <div className={styles.lottery}>
            {locale !== 'au' && (
                <div className="lottery-img">
                    <EFPic name={imgName} />
                </div>
            )}
            <div className="lottery-box">
                <div className="lottery-title">{lotteryData.title}</div>
                <div className="lottery-progress">
                    <div className="progress-line" style={{ height: `${progressHeight}px` }}></div>
                    <div className="active-line" style={{ height: `${activeHeight}px` }}></div>
                    {lotteryData.list.map((item: Record<string, string | string[] | number>, i: number) => (
                        <div className="lottery-item" key={i}>
                            <div
                                className={`item-circle ${item.number > completeNumber ? `circle-opacity-${i + 1}` : 'circle-opacity-1'}`}
                                // style={{ backgroundColor: item.number > completeNumber ? '#cc5f3a' : '#FF7748' }}
                            >
                                <span className="circle-text">{item.h5Num || item.num}</span>
                            </div>
                            <div
                                className="item-box"
                                style={{
                                    boxShadow: item.number > completeNumber ? '0 0 0 0.5px #979797' : '0 0 0 0.5px #FF7748',
                                    opacity: item.number > completeNumber ? 1 - 0.2 * i : 1,
                                }}
                            >
                                <div className="left-item">
                                    <div className="lottery-product">
                                        {item.productName}
                                        {['ca', 'us'].includes(locale as string) && <span onClick={() => handleMarkClick(i)} className="svg-detail"></span>}
                                    </div>
                                    <div
                                        className={`winner-btn ${hideWinner && !enableArr[i]?.hasWinnerList ? 'hide-winner' : ''} ${
                                            !hideWinner && !enableArr[i]?.hasWinnerList ? 'disabled-winner' : ''
                                        }`}
                                        onClick={() => {
                                            if (!!enableArr[i]?.hasWinnerList) {
                                                showWinnerList(item, i + 1).catch(console.error);
                                            }
                                        }}
                                    >
                                        {lotteryData.winnerList}
                                    </div>
                                </div>
                                <div className="right-item">
                                    <EFPic name={item.src} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="svg-box">
                <div className="item-box">
                    <div
                        className="svg-item"
                        style={{ background: `url("${svgList[0].svg}")` }}
                        onClick={() => {
                            gtmPush('Instagram');
                            window.open(svgList[0].link);
                        }}
                    ></div>
                </div>
                {!['kr'].includes(locale as string) && (
                    <div className="item-box">
                        <TwitterShareButton url={locationHref} onClick={() => gtmPush('Twitter')}>
                            <div className="svg-item" style={{ background: `url("${svgList[1].svg}")` }}></div>
                        </TwitterShareButton>
                    </div>
                )}
                {['kr'].includes(locale as string) && (
                    <div
                        className="item-box"
                        onClick={() => {
                            window.open(svgList[1].link);
                        }}
                    >
                        <div className="svg-item" style={{ background: `url("${svgList[1].svg}")` }}></div>
                    </div>
                )}
                <div className="item-box">
                    <FacebookShareButton url={locationHref} onClick={() => gtmPush('Facebook')}>
                        <div className="svg-item" style={{ background: `url("${svgList[2].svg}")` }}></div>
                    </FacebookShareButton>
                </div>
                <div className="item-box" onClick={() => gtmPush('Email')}>
                    <EmailShareButton url={locationHref}>
                        <div className="svg-item" style={{ background: `url("${svgList[3].svg}")` }}></div>
                    </EmailShareButton>
                </div>
            </div>
            <div className="lottery-tip">{lotteryData.h5Desc || lotteryData.desc}</div>
            <div className="lottery-link" style={locale !== 'jp' ? { color: '#fff' } : {}} onClick={handleLinkClick}>
                {lotteryData.linkText}
            </div>
            {visible && (
                <DialogBox onClose={handleDialogClose}>
                    <div className="dialog-rules">
                        <div className="rules-title">{t('rules_title')}</div>
                        <div className="rules-content">{renderDialogContext()}</div>
                    </div>
                </DialogBox>
            )}
            {winnerDialog && (
                <DialogBox
                    onClose={() => {
                        setWinnerDialog(false);
                        setWinnerList([]);
                    }}
                >
                    <div className="winner-box">
                        <div className="winner-title">{lotteryData.winnerList}</div>
                        {!isCoupon && (
                            <div className="winner-content">
                                {winnerList.map((item, index) => (
                                    <div key={index} className="winner-item">
                                        {item}
                                    </div>
                                ))}
                            </div>
                        )}
                        {isCoupon && <div className="coupon-text">{lotteryData.couponText}</div>}
                    </div>
                </DialogBox>
            )}
            {productInfoVisible && (
                <DialogBox onClose={() => handleMarkClick(-1)} style={{ height: '200px' }}>
                    <div className="product-mark">
                        {
                            <>
                                <div className="product-info-name">{productInfoData[markIndex].productName}</div>
                                <div className="product-info-container">
                                    {productInfoData[markIndex].info.map((infoItem: any) => (
                                        <div className="product-info-item">{infoItem}</div>
                                    ))}
                                </div>
                            </>
                        }
                    </div>
                </DialogBox>
            )}
        </div>
    );
}
